export enum FarmType {
    FarmOwner = 1,
    FarmManager = 2
  }